"use client";
function o(r) {
  return r.toLowerCase().replace(/(^\w+:|^)\/\//, "").replace(/^www\./, "").replace(/\/$/, "").startsWith("github.com");
}
function s(r) {
  const t = r.split(" ");
  for (const e of t)
    if (e[0] !== e[0].toUpperCase() || e.slice(1) !== e.slice(1).toLowerCase())
      return !1;
  return !0;
}
export {
  o as isGitHubUrl,
  s as isTitleCase
};
